import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function NewBorn() {
  const [imageRef, imageVisible] = useScrollAnimation();
  const [textRef, textVisible] = useScrollAnimation();
  const { t } = useTranslation();

  return (
    <div className="newBorn-wrapper">
      <div className="newBorn container">
        <img
          ref={imageRef}
          src="/assets/images/newborn.jpg"
          alt="Newborn"
          className={imageVisible ? "animate-in" : ""}
        />
        <p ref={textRef} className={textVisible ? "animate-in" : ""}>
          {t("newBorn.description")}
        </p>
      </div>
    </div>
  );
}

export default NewBorn;
